import React, { useState } from 'react';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

const ForgotPasswordForm = ({ onBack, onSuccess }) => {
  const [step, setStep] = useState(1); // 1: email, 2: code + new password
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleRequestCode = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      if (res.ok) {
        toast.success('Si el email existe, enviamos un codigo');
        setStep(2);
      } else {
        toast.error('Error al enviar el codigo');
      }
    } catch {
      toast.error('Error de conexion');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    if (code.length !== 6 || newPassword.length < 6) {
      toast.error('Codigo de 6 digitos y contrasena minimo 6 caracteres');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code, new_password: newPassword })
      });
      const data = await res.json();
      if (res.ok && data.token) {
        localStorage.setItem('token', data.token);
        toast.success('Contrasena actualizada!');
        onSuccess();
      } else {
        toast.error(data.detail === 'INVALID_RESET_CODE' ? 'Codigo invalido o expirado' : 'Error al resetear');
      }
    } catch {
      toast.error('Error de conexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-slate-800/50 rounded-2xl p-6 border border-white/10">
      <h2 className="text-xl font-semibold text-white mb-2 text-center" data-testid="forgot-password-title">
        Recuperar Contrasena
      </h2>
      <p className="text-slate-400 text-sm text-center mb-6">
        {step === 1 ? 'Te enviaremos un codigo a tu email' : `Ingresa el codigo enviado a ${email}`}
      </p>

      {step === 1 ? (
        <form onSubmit={handleRequestCode}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-slate-700/50 text-white px-4 py-3 rounded-xl mb-4 focus:outline-none focus:ring-2 focus:ring-emerald-500"
            required
            data-testid="forgot-email-input"
            autoFocus
          />
          <button
            type="submit"
            disabled={loading || !email}
            className="w-full bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 text-white py-3 rounded-xl font-medium transition-colors"
            data-testid="forgot-request-btn"
          >
            {loading ? 'Enviando...' : 'Enviar codigo'}
          </button>
        </form>
      ) : (
        <form onSubmit={handleReset}>
          <input
            type="text"
            inputMode="numeric"
            maxLength={6}
            placeholder="000000"
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
            className="w-full bg-slate-700/50 text-white text-center text-2xl tracking-[0.5em] font-bold px-4 py-4 rounded-xl mb-3 focus:outline-none focus:ring-2 focus:ring-emerald-500"
            required
            data-testid="forgot-code-input"
            autoFocus
          />
          <input
            type="password"
            placeholder="Nueva contrasena (min 6)"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            minLength={6}
            className="w-full bg-slate-700/50 text-white px-4 py-3 rounded-xl mb-4 focus:outline-none focus:ring-2 focus:ring-emerald-500"
            required
            data-testid="forgot-new-password-input"
          />
          <button
            type="submit"
            disabled={loading || code.length !== 6 || newPassword.length < 6}
            className="w-full bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 text-white py-3 rounded-xl font-medium transition-colors mb-3"
            data-testid="forgot-reset-btn"
          >
            {loading ? 'Actualizando...' : 'Cambiar contrasena'}
          </button>
          <button
            type="button"
            onClick={() => setStep(1)}
            className="w-full text-slate-400 text-sm hover:text-white transition-colors"
          >
            Reenviar codigo
          </button>
        </form>
      )}

      <button
        type="button"
        onClick={onBack}
        className="w-full mt-4 text-slate-400 text-sm hover:text-white transition-colors"
        data-testid="forgot-back-btn"
      >
        Volver al login
      </button>
    </div>
  );
};

export default ForgotPasswordForm;
